<!-- <div class="tabs-main-wraper overflow-hidden gap-0">
    <div class="cont flex flex-row justify-start m-0">

        <ng-container *ngFor="let tab of fields; let i = index">
            <div tabindex="0" *ngIf="!tab.disabled" [id]="tab.title"
                [ngClass]="{'ml-1.5': i == 0, 'mr-1.5': i == (fields.length-1)}"
                class="m-0 tab-b p-2 cursor-pointer disabled:cursor-not-allowed tabs-hover rounded-t-xl {{tab.routerOutlet == active ? 'text-white' : 'text-text' }} "
                [routerLink]="tab.routerOutlet" [ngStyle]="{ 'background-color': getTabBackground(tab) }">
                {{tab.title}}
            </div>
            <div></div>
            <div tabindex="0" *ngIf="tab.disabled" [id]="tab.title"
                class="m-0 tab-b p-2 cursor-not-allowed tabs-hover rounded-t-xl opacity-30" disabled
                [ngStyle]="{ 'background-color': getTabBackground(tab)}">
                {{tab.title}}
            </div>
        </ng-container>
    </div>
    <div class="h-4 w-full rounded-3xl"
        [ngStyle]="{'background-color': options?.background || 'var(--color-primary-500)'}">
        ⠀
    </div>
</div> -->


<div id="custom-tabs-component" class="relative flex flex-col justify-center items-center " *ngIf="fields">
    <div class="rounded-full backdrop-blur-xl bg-moving p-2 shadow-xl ">

        <div class="flex w-full gap-2  {{isMobile ? 'justify-start text-md' : 'justify-center  rounded-full text-xl '}}  items-center  element-container before:rounded-full {{isMobile ? 'before:invisible' :''}}" style="max-width: 80dvw; overflow: auto; scrollbar-width: none">

            <div *ngFor="let tab of fields; let i = index" class="w-full"> <!-- aggiungi keypress -->

                <div [id]="tab.routerOutlet" tabindex="{{i}}"
                    (click)="navigateToPage(tab.routerOutlet,tab.routerParams);selectElement(tab.routerOutlet);"
                    class="w-full whitespace-nowrap  tab transition-all duration-300 cursor-pointer disabled:cursor-not-allowed rounded-full p-2 step-active hover:bg-primary-800/20 hover:text-white {{active == tab.routerOutlet ? isMobile ? 'bg-primary-500 selected': 'selected' : 'text-primary-500'}} ">
                    {{tab.title}}
                </div>

            </div>
        </div>
    </div>
</div>



<!-- <div class="flex justify-between items-center w-full" *ngIf="isMobile"> -->

<!-- 
    <div id="custom-tabs-component" class="flex flex-col justify-center items-center " *ngIf="fields">
        <div class="rounded-full backdrop-blur-xl bg-moving p-2 shadow-xl ">
    
            <div class="flex  gap-2 justify-center items-center  rounded-full  element-container ">
    
                <div *ngFor="let tab of fields; let i = index"> 
    
                    <button [id]="tab.routerOutlet" tabindex="{{i}}"
                        (click)="selectElement(tab.routerOutlet);navigateToPage(tab.routerOutlet,tab.routerParams)"
                        class=" tab transition-all duration-300 cursor-pointer disabled:cursor-not-allowed rounded-full p-2  text-xl step-active hover:bg-primary-800/20 hover:text-white {{active == tab.routerOutlet ? 'selected bg-primary-500' : 'text-primary-500'}} ">
                        {{tab.title}}
                    </button>
    
    
    
                </div>
            </div>
        </div>
    </div> -->

    <!--previous-->
    <!-- <div class="flex flex-col justify-center items-center w-1/6" *ngIf="previous">
        <div (click)="showList = false"
            class="text-primary-800 bg-primary-100 p-2 rounded-full text-xl flex items-end justify-end w-10/12"
            [routerLink]="[previous.routerOutlet, previous.routerParams]">

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M15 6l-6 6l6 6" />
            </svg>

        </div>

    </div>
    <div class="flex flex-col justify-center items-center w-1/6" *ngIf="!previous">
        <div (click)="showList = false"
            class="text-primary-500/20 bg-primary-50 p-2 rounded-full text-xl flex items-end justify-end w-10/12">

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M15 6l-6 6l6 6" />
            </svg>

        </div>

    </div> -->

    <!-- current -->
<!--     <div class="flex flex-col justify-center items-center w-4/6">
        <div class="rounded-3xl p-2 w-full text-xl bg-primary-500 text-white shadow-xl" (click)="showList = !showList">
            <p [id]="current?.title + 'p'" class="text-center p-2 whitespace-normal">{{current?.title}}</p>
        </div>

    </div> -->

    

    <!-- next -->
<!--     <div class="flex flex-col justify-center items-center w-1/6" *ngIf="next">
        <div (click)="showList = false"
            class="text-primary-800 bg-primary-100 p-2 rounded-full text-xl flex items-end justify-end w-10/12"
            [routerLink]="[next.routerOutlet, next.routerParams]">

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M9 6l6 6l-6 6" />
            </svg>

        </div>

    </div>
    <div class="flex flex-col justify-center items-center w-1/6" *ngIf="!next">
        <div (click)="showList = false"
            class="text-primary-500/20 bg-primary-50 p-2 rounded-full text-xl flex items-end justify-end w-10/12">

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M9 6l6 6l-6 6" />
            </svg>

        </div>

    </div> -->

    <!-- fake invisible button -->


<!-- </div> -->





<!-- 
<div @slideDownUp class="flex flex-col gap-2 items-start justify-between w-full mt-4 p-2 bg-primary-50 rounded-2xl" *ngIf="showList && isMobile">
    <div *ngFor="let tab of fields; let i = index" class="w-full"> 

        <button [id]="tab.routerOutlet" tabindex="{{i}}"
            (click)="navigateToPage(tab.routerOutlet,tab.routerParams)"
            class="bg-primary-500 text-primary-50 p-2 rounded-2xl w-full">
            {{tab.title}}
        </button>



    </div>
</div> -->
